
















import { defineComponent } from "@vue/composition-api";
import BaseButton from "@/components/BaseButton";

export default defineComponent({
  name: "SubscriptionOfferCard",
  components: { BaseButton },
  props: {
    showTitle: { type: Boolean },
  },
});
